import { ApiMap } from '@/constants';

export type ParsedEnvVariables = {
  imageTag: string | undefined;
  env: string | undefined;
  clusterName: string | undefined;
  portableMode: boolean | undefined;
  defaultSite?: SiteWithApis;
  /** Deployment kill switch: when true, HLS rewind (DVR) is force-disabled for every
      user regardless of their per-user preference. Overrides the user setting. */
  videoRecallDisabled?: boolean;
};

export interface EnvironmentConfig {
  defaultSite?: string;
  image_tag?: string;
  env?: string;
  cluster_name?: string;
  portable_mode?: string;
  /** "true" disables HLS rewind (DVR) fleet-wide (see {@link ParsedEnvVariables.videoRecallDisabled}). */
  video_recall_disabled?: string;
}

export interface SiteConfig {
  name: string;
  /** Inventory id (`SiteInventory.id`), required by the cloud endpoints that take a site id. */
  id: string;
  /** Host this site is reached on, e.g. `southshore-bergen.edge.scaleaq.net`. Legacy records
      hold only the cluster name; {@link DEFAULT_EDGE_DNS_ZONE} is assumed for those. */
  baseUrl: string;
  includeScaleInternal?: boolean;
  apis?: ApiMap;
}

export interface SiteWithApis extends SiteConfig {
  apis: ApiMap;
}

export const storeNames = {
  bargeControl: 'bargeControl-storage',
  biomassDistribution: 'biomass-distribution-preferences',
  config: 'sitecontrol_config_storage',
  devSettings: 'devSettings',
  layout: 'layout-storage',
  orbitOneVisibility: 'orbitOne-visibility-storage',
  selectedSite: 'selected-site-storage',
  sensorLed: 'SensorLedStateStorage',
  userSettings: 'userSettings',
  welfareIndicator: 'welfare-indicator-config',
  welfareIndicatorPreferences: 'welfare-indicator-preferences',
};
